import { render, staticRenderFns } from "./customer_payments.vue?vue&type=template&id=35bb9816&scoped=true&"
import script from "./customer_payments.vue?vue&type=script&lang=ts&"
export * from "./customer_payments.vue?vue&type=script&lang=ts&"
import style0 from "./customer_payments.vue?vue&type=style&index=0&id=35bb9816&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb9816",
  null
  
)

export default component.exports